import { createSlice } from "@reduxjs/toolkit";
import {
  getAuthToken,
  parseStoredUser,
  clearAuthStorage,
} from "@/utils/authStorage";

const storedUser = parseStoredUser();
const storedToken = getAuthToken();
const isAuthenticated = Boolean(storedUser && storedToken);

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: storedUser,
    isAuth: isAuthenticated,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuth = Boolean(action.payload && getAuthToken());
    },
    logOut: (state) => {
      state.user = null;
      state.isAuth = false;
      clearAuthStorage();
    },
  },
});

export const { setUser, logOut } = authSlice.actions;
export default authSlice.reducer;
